import { AutenticacionService, ModulosARK, TipoPermiso } from './../../services/autenticacion.service';
import { SecurityModalComponent } from './../partials/security-modal/security-modal.component';
import { ReportesService } from './../../services/reportes.service';
import { DomSanitizer } from '@angular/platform-browser';
import { HelpersService } from './../../services/tools/helpers.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ReporteResumenOyvService } from '../../services/reporte-resumen-oyv.service';
import { Subscription } from 'rxjs/Subscription';
import { forkJoin } from 'rxjs/observable/forkJoin';

@Component({
  selector: 'app-reporte-resumen-oyv',
  templateUrl: './reporte-resumen-oyv.component.html',
  styleUrls: ['./reporte-resumen-oyv.component.scss']
})
export class ReporteResumenOyv implements OnInit {
  @ViewChild(SecurityModalComponent) securityModal: SecurityModalComponent;
  public fecha_actual: any;
  public fecha_filter: any;
  public fecha_filter_final: any; 
  public fecha_selected: any;
  public fecha_inicial_filter: any;
  public fecha_inicial_selected: any;
  public fecha_final_filter: any;
  public fecha_final_selected: any;
  public fecha_generado: any;
  public loading_report: any = false;
  public show_report: any = true;
  public not_report: any = false;
  public printing: boolean = false;
  public reportes_lista: any[] = [];
  public reporte_actual: any;
  public fechaInicialLabel:string;
  public fechaFinalLabel:string;
  public fechaGeneradoLabel:string;
  public first_load: boolean = true;
  public totaloyv = 0;
  public totalkr = 0;
  public totalreembolso = 0;
  public totalreforma = 0;
  public totallondres = 0;
  public totalinsurgentes = 0;
  public totalop = 0;
  public totalingresosgeneral = 0;
  public totalegresosgeneral = 0;
  private subscriptions: Array<Subscription> = [];
  public totales: any[] = [];


  constructor(private reportesService: ReportesService,
                private ReporteResumenOyvService: ReporteResumenOyvService,
                private helperService: HelpersService,
                private router: Router,
                private helpersService: HelpersService,
                private sanitizer: DomSanitizer, 
                private authService: AutenticacionService) { }



  ngOnInit() {
    let reportes_lista = this.reportesService.getListaReportes();
    // console.log("reportes_lista:",JSON.stringify(reportes_lista));
    for (let i = 0; i < reportes_lista.length; i++) {  
      if(reportes_lista[i]["id"] == 1 && this.authService.tienenPermisos(ModulosARK.ReportePorInversionista, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 2 && this.authService.tienenPermisos(ModulosARK.ReporteResumenDeObra, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 3 && this.authService.tienenPermisos(ModulosARK.ReportePorObra, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 4 && this.authService.tienenPermisos(ModulosARK.ReporteBalanceKr, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 5 && this.authService.tienenPermisos(ModulosARK.ReportePuntoDeEquilibrio, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 6 && this.authService.tienenPermisos(ModulosARK.ReporteResumenDeDiferencia, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 7 && this.authService.tienenPermisos(ModulosARK.ReporteSaldos, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 8 && this.authService.tienenPermisos(ModulosARK.ReporteDepositoGarantia, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }
      if(reportes_lista[i]["id"] == 9 && this.authService.tienenPermisos(ModulosARK.ReporteCobranza, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
      }if(reportes_lista[i]["id"] == 10 && this.authService.tienenPermisos(ModulosARK.ReporteResumenOyv, TipoPermiso.Lectura)){
        this.reportes_lista.push(reportes_lista[i]);
        this.reporte_actual = reportes_lista[i]; //reporte resumen oyv
      }
    }
    this.getFechaActual();    
  }

  changeReporte(reporte) {
    if (reporte.id && reporte.id != this.reporte_actual.id) {
      this.router.navigate([reporte.ruta]);
    }
  }

  changeFilterFecha(fecha) {
    this.fecha_filter = fecha;
    this.getReporte();
  }

  changeFilterFechaFin(fecha) {
    this.fecha_filter_final = fecha;
    this.getReporte();
    this.first_load=false;//provisional
  }

  getFechaActual() {
    console.log("obteniendo fecha actual")
    this.reportesService.getFechaActual()
        .subscribe((response) => {
          const content = response.json().content;
          console.log("getFechaActual: ",content);
          this.fecha_actual = content.fecha;
          this.fecha_filter = content.fechaInicio;
          this.fecha_filter_final = content.fechaFinal;
        }, (error) => {
          // se revisan errores 403 - 500
          this.helperService.httpGlobalError(error);
          if (error == 400) {
            console.log('getFechasActual - error 400 ' , error);
          }
        });
  }

  getReporte(){
    
    if(this.first_load){      
      return
    }
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
    this.loading_report = true;
    this.show_report = false;
    console.log("fecha_filter: ",this.fecha_filter);
    console.log("fecha_filter_final: ",this.fecha_filter_final);
    this.subscriptions.push(this.ReporteResumenOyvService.getFechaReporte(this.fecha_filter, this.fecha_filter_final)
      .subscribe((response) => {
        const content_response = response.json().content;
        console.log("getFechaReporte: ",content_response);
        this.fechaInicialLabel = content_response["fechas"]["fechaInicialFormato"];
        this.fechaFinalLabel = content_response["fechas"]["fechaFinalFormato"];
        this.fechaGeneradoLabel = content_response["fecha_generadoFormato"];
        this.generarTotales();
      }, (error) => {
      // resuelve errores 403, 500 y sin conexión.
      this.helpersService.httpGlobalError(error);
      this.loading_report = false;
      this.show_report = false;
      this.not_report = true;
    }));
  }

  generarTotales(){
    this.ReporteResumenOyvService.getReporteOyvTotales(1, this.fecha_filter_final, false)
    .subscribe(response => {  
      const content_response = response.json().content;
      this.totales["oyv"] = content_response;
      this.ReporteResumenOyvService.getReporteOyvTotales(21, this.fecha_filter_final, false)
      .subscribe(response => {  
        const content_response = response.json().content;
        this.totales["reforma"] = content_response;
        this.ReporteResumenOyvService.getReporteOyvTotales(15, this.fecha_filter_final, false)
        .subscribe(response => {  
          const content_response = response.json().content;
          this.totales["londres"] = content_response;
          this.ReporteResumenOyvService.getReporteOyvTotales(11, this.fecha_filter_final, false)
          .subscribe(response => {  
            const content_response = response.json().content;
            this.totales["insurgentes"] = content_response;
            this.ReporteResumenOyvService.getReporteOyvTotales(17, this.fecha_filter_final, false)
            .subscribe(response => {  
              const content_response = response.json().content;
              this.totales["op"] = content_response;
              this.ReporteResumenOyvService.getReporteOyvTotales(13, this.fecha_filter_final, false)
              .subscribe(response => {  
                const content_response = response.json().content;
                this.totales["kr"] = content_response;
                console.log(this.totales);                
                this.totalkr = this.totales["kr"].totales.total_ingresos - this.totales["kr"].totales.total_egresos;
                this.totaloyv = this.totales["oyv"].totales.total_ingresos - this.totales["oyv"].totales.total_egresos;
                this.totalreforma = this.totales["reforma"].totales.total_ingresos - this.totales["reforma"].totales.total_egresos;
                this.totallondres = this.totales["londres"].totales.total_ingresos - this.totales["londres"].totales.total_egresos;
                this.totalinsurgentes = this.totales["insurgentes"].totales.total_ingresos - this.totales["insurgentes"].totales.total_egresos;
                this.totalop = this.totales["op"].totales.total_ingresos - this.totales["op"].totales.total_egresos;
                this.totalingresosgeneral = this.totales["kr"].totales.total_ingresos + this.totales["oyv"].totales.total_ingresos + this.totales["reforma"].totales.total_ingresos + this.totales["londres"].totales.total_ingresos + this.totales["insurgentes"].totales.total_ingresos + this.totales["op"].totales.total_ingresos;
                this.totalegresosgeneral = this.totales["kr"].totales.total_egresos + this.totales["oyv"].totales.total_egresos + this.totales["reforma"].totales.total_egresos + this.totales["londres"].totales.total_egresos + this.totales["insurgentes"].totales.total_egresos + this.totales["op"].totales.total_egresos;
                this.not_report = false;
                this.loading_report = false;
                this.show_report = true;
              }, error => {
                this.helperService.httpGlobalError(error);
                this.loading_report = false;
                this.show_report = false;
                this.not_report = true;
              }
              );
            }, error => {
              this.helperService.httpGlobalError(error);
              this.loading_report = false;
              this.show_report = false;
              this.not_report = true;
            }
            );
          }, error => {
            this.helperService.httpGlobalError(error);
            this.loading_report = false;
            this.show_report = false;
            this.not_report = true;
          }
          );
        }, error => {
          this.helperService.httpGlobalError(error);
          this.loading_report = false;
          this.show_report = false;
          this.not_report = true;
        }
        );
      }, error => {
        this.helperService.httpGlobalError(error);
        this.loading_report = false;
        this.show_report = false;
        this.not_report = true;
      }
      );
    }, error => {
      this.helperService.httpGlobalError(error);
      this.loading_report = false;
      this.show_report = false;
      this.not_report = true;
    }
    );
  }


  canSecurity() {
    return this.reportesService.canSecurity();
  }

  print() {
    this.printing = true;
    setTimeout(() => {
      window.print();
    }, 1200);
    window.onafterprint = window.onbeforeprint= () => {
      console.log('end to print');
      this.printing = false;
    };
  }

}


// WEBPACK FOOTER //
// ./src/app/components/reporte-resumen-oyv/reporte-resumen-oyv.component.ts